import { useIsHarmonyTheme } from '@wix/core-domain-search';
export const useGatePageBackground = () => useIsHarmonyTheme() ? 'var(--wds-color-fill-surface-sunken)' : 'white';
//# sourceMappingURL=useGatePageBackground.js.map